import { observable, computed, action } from 'mobx';
import { exportType, exportPaths, DEFAULT_PATH} from '../../constants/constants';
import { handleDownload } from '../../utils/saveFile';
import { createUrl } from '../../utils/utils';
import { Brand } from '../../utils/types';
import { isHostnameContainsCC } from '@pes-ui/utils';

export class DocumentsStore {
  @observable filesLoading = [];

  constructor(rootStore) {
    this.documentsAPI = rootStore.services.documentsAPI;
    this.isPublic = rootStore.isPublic;
  }

  @computed get isLoading() {
    return !!this.filesLoading.length;
  }

  getDownloadUrl(fileFormat) {
    const languageCode = this.documentsAPI.languageCode;
    const countryCode = isHostnameContainsCC() ? '' : `/${this.documentsAPI.countryCode}`;
    if(fileFormat === exportType.MY_PRODUCTS_XML) {
      return createUrl({
        endpoint: exportPaths[exportType.MY_PRODUCTS_XML].path,
        queryParams: {
          brand: Brand.SE_BRAND,
          'country-code': this.documentsAPI.countryCode, 
          'language-code': languageCode,
        }
      });
    }

    let brand = '';
    if(!this.isPublic) {
      brand = `/${Brand.SE_BRAND}`;
    }

    return `${brand}${countryCode}/${languageCode}${exportPaths[fileFormat].path ?? DEFAULT_PATH}`;
  }

  async downloadFile(fileFormat,fileName) {
    if (this.filesLoading.indexOf(fileFormat) > -1) return;
    const downloadUrl = this.getDownloadUrl(fileFormat)
      try {
        await handleDownload(downloadUrl,fileName)  
      } catch(error) {
        console.error('Cannot download PDF file',error);
      }
  }

  @action.bound
  manageLoading(fileFormat) {
    const index = this.filesLoading.indexOf(fileFormat);

    if (index > -1) {
      this.filesLoading.splice(index, 1);
    } else {
      this.filesLoading.push(fileFormat);
    }
  }
}